import * as React from "react";
import PaymentLayout from "../layout/paymentLayout";
import Info from "./info";


const withLayout = (Component: React.Element) => function LayoutWrapper(props: any) {
    return (
        <PaymentLayout>
            <Component {...props} />
        </PaymentLayout>
    );
};

export default {
    Info: withLayout(Info),
};